import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

export const SalesServiceOrderVariantIdsRequestBodySchema = z.object({
  serviceOrderVariantIds: z.array(z.string().uuid()),
});

export type SalesServiceOrderVariantIdsRequestBody = z.infer<
  typeof SalesServiceOrderVariantIdsRequestBodySchema
>;

export const PostSalesServiceOrderVariantSetAsActiveApiArgSchema = z.object({
  body: SalesServiceOrderVariantIdsRequestBodySchema,
});

export type PostSalesServiceOrderVariantSetAsActiveApiArg = z.infer<
  typeof PostSalesServiceOrderVariantSetAsActiveApiArgSchema
>;

export const PostSalesServiceOrderVariantSetAsInactiveApiArgSchema = z.object({
  body: SalesServiceOrderVariantIdsRequestBodySchema,
});

export type PostSalesServiceOrderVariantSetAsInactiveApiArg = z.infer<
  typeof PostSalesServiceOrderVariantSetAsInactiveApiArgSchema
>;

export type PostSalesServiceOrderVariantSetAsActiveApiResponse = z.infer<
  typeof BaseVoidResponseSchema
>;

export type PostSalesServiceOrderVariantSetAsInactiveApiResponse = z.infer<
  typeof BaseVoidResponseSchema
>;

export const PostSalesServiceOrderVariantSetAsDefaultApiArgSchema = z.object({
  serviceOrderVariantId: z.string().uuid(),
});

export type PostSalesServiceOrderVariantSetAsDefaultApiArg = z.infer<
  typeof PostSalesServiceOrderVariantSetAsDefaultApiArgSchema
>;

export type PostSalesServiceOrderVariantSetAsDefaultApiResponse = z.infer<
  typeof BaseVoidResponseSchema
>;

export const PostSalesServiceOrderVariantUnsetAsDefaultApiArgSchema = z.object({
  serviceOrderVariantId: z.string().uuid(),
});

export type PostSalesServiceOrderVariantUnsetAsDefaultApiArg = z.infer<
  typeof PostSalesServiceOrderVariantUnsetAsDefaultApiArgSchema
>;

export type PostSalesServiceOrderVariantUnsetAsDefaultApiResponse = z.infer<
  typeof BaseVoidResponseSchema
>;

export const GetServiceCasesByBusinessCaseApiArgSchema = z.object({
  businessCaseId: z.string(),
});

export type GetServiceCasesByBusinessCaseApiArg = z.infer<
  typeof GetServiceCasesByBusinessCaseApiArgSchema
>;

export const ServiceCaseByBusinessCaseSchema = z.object({
  serviceCaseId: z.string(),
  branchId: z.string(),
  authorizationProfileId: z.string(),
  state: z.string(),
  number: z.string(),
  createdAt: z.string(),
  createdBy: z.string(),
});

export const GetServiceCasesByBusinessCaseApiResponseSchema = z.array(
  ServiceCaseByBusinessCaseSchema
);

export type GetServiceCasesByBusinessCaseApiResponse = z.infer<
  typeof GetServiceCasesByBusinessCaseApiResponseSchema
>;

export const PostServiceCasesByBusinessCaseApiArgSchema = z.object({
  businessCaseId: z.string(),
  body: z.array(z.object({serviceCaseId: z.string()})),
});

export type PostServiceCasesByBusinessCaseApiArg = z.infer<
  typeof PostServiceCasesByBusinessCaseApiArgSchema
>;

export type PostServiceCasesByBusinessCaseApiResponse = z.infer<typeof BaseVoidResponseSchema>;
